<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_right">
        <img
          class="navbar_logo"
          src="@/assets/img/home/logo.png"
          alt="logo"
          @click="$router.push('/home')"
          style="cursor: pointer"
        />
        <ul class="el_menu_demo">
          <li 
            v-for="(item, index) in menuItems"
            :key="index"
            class="menu_item" 
            :class="{ 'is-active': activeIndex === item.index }"
            @click="changeCurrentPage(item.index)"
          >
            {{ item.label }}
          </li>
        </ul>
        <div class="nav_btn">
          <div class="nav_btn_view" @click="gotoChat">
            <img class="nav_btn_view_icon" src="@/assets/img/home/home_icon.png"/>
            <span class="nav_btn_view_text">解锁碳芯无限可能</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      menuItems: [
        { index: '1', label: '首页', path: '/home' },
        { index: '2', label: '“碳芯”大模型', path: '/production' },
        { index: '3', label: '产品&服务', path: '/service' },
        { index: '4', label: '“可持续先锋”计划', path: '/pioneer' },
        // { index: '3', label: '“碳中枢”Agent', path: '/carbon' },
        { index: '5', label: '关于我们', path: '/about' }
      ],
      navBackground: 'transparent',
      scrollThreshold: 100,
      isHomePage: false,
      scrollListener: null,
      customScrollListener: null
    }
  },
  props: {
    selectIndex: {
      type: String,
      default: '0',
    },
    currentIndex: {
      type: Number,
      default: -1
    },
    section3ScrollTop: {
      type: Number,
      default: 0
    }
  },
  watch: {
    currentIndex: {
      handler(newIndex) {
        if (newIndex >= 0) {
          this.handlePageScroll(newIndex);
        }
      },
      immediate: true
    },
    section3ScrollTop: {
      handler(newScrollTop) {
        if (this.currentIndex >= 0) {
          this.handleSection3Scroll(newScrollTop);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.activeIndex = this.selectIndex;
    this.isHomePage = this.currentIndex >= 0;
    if (!this.isHomePage) {
      this.addScrollListener();
    } else {
    }
  },
  beforeDestroy() {
    // 如果不是Home页面，移除window滚动监听
    if (!this.isHomePage && this.scrollListener) {
      this.removeScrollListener();
    }
  },
  methods: {
    changeCurrentPage(index) {
      this.activeIndex = index
      const item = this.menuItems.find(item => item.index === index)
      if (item && item.path) {
        this.$router.push(item.path).catch((v) => {})
      }
    },

    // 处理页面滚动（Home页面专用）
    handlePageScroll(currentIndex) {
      // 计算虚拟滚动距离：每个屏幕高度为100vh
      const virtualScrollTop = currentIndex * window.innerHeight;
      // 当滚动超过100px时切换背景色
      if (virtualScrollTop > this.scrollThreshold) {
        this.navBackground = 'rgba(255, 255, 255, 1)';
      } else {
        this.navBackground = 'transparent';
      }
    },
    
    // 处理第三屏内部滚动（Home页面专用）
    handleSection3Scroll(scrollTop) {
      // 如果当前在第三屏，根据第三屏的滚动位置调整背景色
      if (this.currentIndex === 2 && scrollTop > this.scrollThreshold) {
        this.navBackground = 'rgba(255, 255, 255, 1)';
      } else if (this.currentIndex === 2 && scrollTop <= this.scrollThreshold) {
        this.navBackground = 'transparent';
      }
    },
    
    // 添加window滚动监听（其他页面专用）
    addScrollListener() {
      this.scrollListener = this.handleWindowScroll.bind(this);
      window.addEventListener('scroll', this.scrollListener, { passive: true });
      // 同时尝试监听自定义滚动容器
      this.addCustomScrollListener();
      // 立即调用一次，确保初始状态正确
      this.handleWindowScroll();
    },
    
    // 添加自定义滚动容器监听
    addCustomScrollListener() {
      // 延迟执行，确保DOM已渲染完成
      this.$nextTick(() => {
        // 查找页面中的滚动容器
        const scrollContainers = document.querySelectorAll('.section-3-container.scrollable, .scrollable, [ref="scrollContainer"]');
        if (scrollContainers.length > 0) {
          this.customScrollListener = this.handleCustomScroll.bind(this);
          // 为每个滚动容器添加监听
          scrollContainers.forEach(container => {
            container.addEventListener('scroll', this.customScrollListener, { passive: true });
          });
          // 立即调用一次，确保初始状态正确
          this.handleCustomScroll();
        }
      });
    },

    // 移除window滚动监听（其他页面专用）
    removeScrollListener() {
      if (this.scrollListener) {
        window.removeEventListener('scroll', this.scrollListener);
        this.scrollListener = null;
      }
      // 移除自定义滚动容器监听
      this.removeCustomScrollListener();
    },
    
    // 移除自定义滚动容器监听
    removeCustomScrollListener() {
      if (this.customScrollListener) {
        const scrollContainers = document.querySelectorAll('.section-3-container.scrollable, .scrollable, [ref="scrollContainer"]');
        scrollContainers.forEach(container => {
          container.removeEventListener('scroll', this.customScrollListener);
        });
        this.customScrollListener = null;
      }
    },

    // 处理window滚动（其他页面专用）
    handleWindowScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // 当滚动超过100px时切换背景色
      if (scrollTop > this.scrollThreshold) {
        this.navBackground = 'rgba(255, 255, 255, 1)';
      } else {
        this.navBackground = 'transparent';
      }
    },

    handleCustomScroll() {
      // 查找页面中的滚动容器
      const scrollContainers = document.querySelectorAll('.section-3-container.scrollable, .scrollable, [ref="scrollContainer"]');
      if (scrollContainers.length > 0) {
        // 获取第一个滚动容器的滚动位置
        const scrollTop = scrollContainers[0].scrollTop || 0;
        // 当滚动超过100px时切换背景色
        if (scrollTop > this.scrollThreshold) {
          this.navBackground = 'rgba(255, 255, 255, 1)';
        } else {
          this.navBackground = 'transparent';
        }
      }
    },

    gotoChat(){
      window.open('https://ai.carbonneutrality-group.com/chat-app/', '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 116px;
  background: transparent;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  font-family: 'Inter';

  .navbar_container {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    // .navbar_left {
    //   display: flex;
    //   align-items: center;
    //   margin-left: 120px;
    //   height: 100%;
    //   img {
    //     width: 160px;
    //     cursor: pointer;
    //   }
    // }

    .navbar_right {
      width: calc(100vw * 1820 / 1920);
      height: calc(100vh * 70 / 1080);
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.75) 100%);
      box-shadow: 0px 10px 30px 0px rgba(166, 208, 213, 0.5);
      backdrop-filter: blur(5px);
      border-radius: 100px;
      
      .navbar_logo {
        width: 225px;
        height: 40px;
        margin-left: 26px;
      }

      .el_menu_demo {
        border: none;
        display: flex;
        list-style: none; // 移除默认列表样式
        padding: 0; // 移除默认内边距
        width: calc(100vw * 775 / 1920);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .menu_item {
          font-size: 20px;
          letter-spacing: 2px;
          border-bottom: none!important;
          font-weight: 300;
          text-align: center;
          list-style: none; // 移除列表项默认样式
          // padding: 0 20px; // 保持原间距
          cursor: pointer;
          position: relative;
          color: rgba(85, 143, 123, 0.75);

          &:hover {
            background: transparent !important;
            color: rgba(85, 143, 123, 0.75)!important;
          }
        }

        .is-active {
          color: rgba(85, 143, 123, 1);
          font-weight: 700;
          font-size: 20px;

          // &::after{
          //   content: '';
          //   position: absolute;
          //   bottom: -40px;
          //   left: 50%;
          //   transform: translateX(-50%);
          //   width: 11px;
          //   height: 11px;
          //   background: linear-gradient(180deg, #83FDFF 0%, #5CB2FF 100%);
          //   border-radius: 50%;
          // }
        }
      }

      .nav_btn{
        width: 285px;
        height: 60px;
        background: rgba(85, 143, 123, 0.35);
        // border: 5px solid rgba(85, 143, 123, 0.35);
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        margin-right: 5px;
        font-size: 24px;
        cursor: pointer;

        .nav_btn_view{
          width: 275px;
          height: 50px;
          margin:5px;
          background: linear-gradient(270deg, #69C3A4 0%, #31715B 100%);
          border-radius: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          position: relative;
          transition: all 0.3s ease;
          overflow: hidden;

          .nav_btn_view_icon{
            width: 26px;
            height: 26px;
            margin-left:14px;
            margin-right: 28px;
            transition: all 1.1s cubic-bezier(0.175, 0.885, 0.32, 1.275); // 更流畅的缓动函数
            flex-shrink: 0;
            position: relative;
            z-index: 2;
            transform: scale(1);
          }

          .nav_btn_view_text{
            transition: all 0.8s ease;
            white-space: nowrap;
            flex-shrink: 0;
            position: relative;
            z-index: 1;
            font-size: 20px;
            font-weight: 300;
          }

          &:hover{
            background: linear-gradient(270deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
            
            .nav_btn_view_icon{
              transform: translateX(230px) scale(1.1);
              margin-left: 0;
              margin-right: 0;
              filter: drop-shadow(2px 2px 4px rgba(0,0,0,0.2));
              content: url('../../assets/img/home/home_icon_hover.png');
            }
            
            .nav_btn_view_text{
              transform: translateX(0);
              background-position: 100% 0;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
}
</style>